import { z } from 'zod'

const contactMethodEnum = z.enum(['whatsapp', 'telegram'])

export const stepAboutYouSchema = z
	.object({
		firstName: z.string().min(1, 'First name is required'),
		lastName: z.string().min(1, 'Last name is required'),
		email: z.string().email('Please enter a valid email address'),
		contactMethods: z.array(contactMethodEnum).max(1),
		whatsappCountryCode: z.string(),
		whatsappNumber: z.string(),
		telegramUsername: z.string(),
		termsAccepted: z.boolean().refine((v) => v === true, {
			message: 'You must accept the terms',
		}),
	})
	.superRefine((data, ctx) => {
		if (data.contactMethods.includes('whatsapp') && !data.whatsappNumber.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Phone number is required for WhatsApp',
				path: ['whatsappNumber'],
			})
		}
		if (data.contactMethods.includes('telegram') && !data.telegramUsername.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Username is required for Telegram',
				path: ['telegramUsername'],
			})
		}
	})

export type StepAboutYouValues = z.infer<typeof stepAboutYouSchema>
